// Validate Empty
export function validateEmpty(value, fieldName, docid) {
  // console.log(value, fieldName);
  // Convert non-string values safely
  const normalizedValue = typeof value === "string" ? value.trim() : value;
  if (!normalizedValue || normalizedValue === 0) {
    let id = document.getElementById(docid);
    if (id) {
      id.scrollIntoView({ behavior: "smooth", block: "center" });
      // id.focus();
    }
    return `Please enter ${fieldName}`;
  }
  return null;
}

// Validate Email
export function validateEmail(value, fieldName) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailRegex.test(value)) {
    return `Please provide a valid ${fieldName}`;
  }
  return null;
}

// Min Length Checking
export function validateMinLength(value, fieldName, minLength) {
  if (value.length < minLength) {
    let id = document.getElementById(fieldName);
    if (id) {
      id.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    return `Please enter at least ${minLength} characters for ${fieldName}`;
  }
  return null;
}

// Max Length Checking
export function validateMax(value, fieldName, maxLength) {
  if (value.length > maxLength) {
    return `Please enter at most ${maxLength} characters for ${fieldName}`;
  }
  return null;
}

export function maxValidate(value, maxLength) {
  if (value > maxLength) {
    return `Maximum allowed value should be ${maxLength}`;
  }
  return null;
}

// Zero Checking
export function ZeroCheck(value, fieldName) {
  if (value == 0) {
    return `Please enter a valid ${fieldName}`;
  }
  return null;
}

export const passwordChecker = (password, confirmPassword) => {
  if (password !== confirmPassword) {
    return "Passwords & Confirm Password does not match";
  }
  return null;
};